import CreatorCreateCollectionPage from "./CreatorCreateCollectionPage";

export default CreatorCreateCollectionPage;